namespace Pages.Test._Controls.Permission {
    export async function __cdn_pages_test_controls_permission_onDocumentReadyAsync() {
        let main = document.querySelector('main');

        let login = new CDN.Controls.Login(main, {
            onLogin: (result) => {
                login.hide();

                let manager = new CDN.Controls.Permission.VehicleUserGroupManager(main, {
                    userToken: result.UserToken,
                });
            }
        });

    }
}

CDN.requireOnce([
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.Control_Permission_User, },
    { code: CDN.PackageCode.Control_Login, },
], () => {
    $(document).ready(Pages.Test._Controls.Permission.__cdn_pages_test_controls_permission_onDocumentReadyAsync);
});
